export const ONLY_NUMBER_AND_DECIMAL_REGEX = '^\\d+(?:[.,]\\d+)?$';

export const ONLY_NUMBER_REGEX = '\\d*';

export const ONLY_TEXT_AND_SPACE_REGEX = '^[a-zA-Z\\s]*$';

export const MOBILE_USER_AGENTS_REGEX = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

export const SINGAPORE_PHONE_NUMBER_REGEX = /^(?:\+65)?(?:[689]\d{7})$/;

export const SINGAPORE_MOBILE_NUMBER_REGEX = /^(?:\+65)?(?:[89]\d{7})$/;

export const SINGAPORE_LANDLINE_REGEX = /^(?:\+65)?(?:6\d{7})$/;
